module.exports = __webpack_public_path__ + "static/ArtemisBlue-c473b7635b5dcbb54c3bc551401be12f.jpg";